import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "67ae103e-2b29-4b6b-8493-207748a2b097",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/09/task/task-01-item-01.svg`,
    },
  },
  {
    id: "f196e78c-63b1-4ff5-8b2b-75e7733bd880",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/09/task/task-01-item-02.svg`,
    },
  },
  {
    id: "c8da8313-32e9-45cc-aa93-c6afef94cdf2",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/09/task/task-01-item-03.svg`,
    },
  },
  {
    id: "c7442cb4-8444-4857-944c-9f5829ded277",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/09/task/task-01-item-04.svg`,
    },
  },
];

export const task: Task = {
  id: "ec1b2d93-e990-4f20-8111-8329c835ad1f",
  type: "orderImages",
  options: {
    shuffle: true,
    groupLabels: [
      "Broadband diffusion</br>(low, mid and high frequencies)",
      "Diffusion above approx. 400 Hz",
      "Diffusion above approx. 800 Hz ",
      "High frequency diffusion only</br>(above approx. 2800 Hz) ",
    ],
    groupLabelsPosition: "below",
  },
  solutionType: "order",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "c7442cb4-8444-4857-944c-9f5829ded277",
    "c8da8313-32e9-45cc-aa93-c6afef94cdf2",
    "67ae103e-2b29-4b6b-8493-207748a2b097",
    "f196e78c-63b1-4ff5-8b2b-75e7733bd880",
  ],
};
